import script from "./GenAIComp.vue?vue&type=script&setup=true&lang=js"
export * from "./GenAIComp.vue?vue&type=script&setup=true&lang=js"

import "./GenAIComp.vue?vue&type=style&index=0&id=7c29536a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c29536a"]])

export default __exports__